module.exports = __webpack_public_path__ + "img/img3.70610bea.png";